import { Injectable } from '@angular/core';
import { SessionStorageKeysEnum } from '../../models/session-storage-keys-enum';
import {environment} from '../../../../environments/environment';

@Injectable()
export class IpUtil {

  getUserIP(): Promise<string> {
    // Solo calcular cuando sea chrome
    return new Promise((OK, ERROR) => {
      // compatibility for firefox and chrome
      const myPeerConnection = window['RTCPeerConnection'] || window['mozRTCPeerConnection'] || window['webkitRTCPeerConnection'];
      const pc = new myPeerConnection({
        iceServers: []
      }),
        noop = function () { }, // NOSONAR
        localIPs = {},
        ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g;
      function iterateIP(ip) {
        if (!localIPs[ip] && ip !== '192.168.43.1') {
          OK(ip);
        }
        localIPs[ip] = true;
      }
      // create a bogus data channel
      pc.createDataChannel('');
      // create offer and set local description
      pc.createOffer().then(function (sdp) {
        sdp.sdp.split('\n').forEach(function (line) {
          if (line.indexOf(SessionStorageKeysEnum.CANDIDATE) < 0) {
            return;
          }
          line.match(ipRegex).forEach(iterateIP);
        });

        pc.setLocalDescription(sdp, noop, noop);
      }).catch(function (reason) {
        // An error occurred, so handle the failure to connect
        ERROR(reason);
      });
      // listen for candidate events
      pc.onicecandidate = function (ice) {
        if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) {
          return;
        }
        ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
      };
    })
  }

    async getPublicIP() {
        return fetch(environment.getPublicIpEndpoint)
            .then(response => response.json())
            .then(data => data.ip)
            .catch(() => '');
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/util/IpUtil.ts